import { apiGet } from '../api/client'
import type { AddressCompletion, AddressMetadata } from './types'

type CompletionsResponse = {
  success: boolean
  completions: AddressCompletion[] | null
}

type VerifyResponse = {
  success: boolean
  matched: boolean
  // Present when matched === true. Same shape as /v1/address/metadata.
  address?: AddressMetadata
}

export async function autocompleteAddress(query: string): Promise<AddressCompletion[]> {
  if (!query.trim()) return []
  const res = await apiGet<CompletionsResponse>('/v1/address/autoComplete', { q: query })
  return res.completions ?? []
}

export async function verifyAddress(query: string): Promise<boolean> {
  const res = await apiGet<VerifyResponse>('/v1/address/verify', { q: query })
  return Boolean(res.matched)
}

/**
 * Like `verifyAddress` but returns the canonical Australia Post record when
 * matched, so callers can feed `legal_parcel_id`, `lot_identifier`,
 * `street_number_1`, etc. into downstream lookups (e.g. HANA). Returns
 * `null` when AP doesn't recognise the address.
 */
export async function verifyAddressMetadata(query: string): Promise<AddressMetadata | null> {
  const res = await apiGet<VerifyResponse>('/v1/address/verify', { q: query })
  return res.matched && res.address ? res.address : null
}

export async function addressMetadata(id: string): Promise<AddressMetadata> {
  return apiGet<AddressMetadata>('/v1/address/metadata', { id })
}
